import {
    ArchiveFolderType,
    MessageSource,
    MessageType,
    ShareFolderTypes,
    ShareFolderUserType
} from "src/Core/Common/Enums";
import { IDocumentRequestFile } from "../documentRequest/DocumentRequestModel";
import { IFileModel } from "../File/FileModel";

export interface IFolderModel {
    folderId: number;
    folderName: string;
    parentFolderIds: string;
    description: string;
    createdBy: number;
    expiresDays: number;
    createdDate: Date;
    parentId: number;
    path?: string;
    folderType?: ArchiveFolderType;
    subFolders?: IFolderModel[];
    owner: string;
    ownerFistName?: string;
    sharedWith?: string;
    sharedWithFirstName?: string;
    permissionGroupId?: ShareFolderTypes;
    isPermissiomInherited?: boolean;
    isPrivate: boolean;
    isFolderNotificationActive? : boolean;
}
export interface IPagination {
    pageSize: number;
    currentPage: number;
    totalRecords: number;
}

export const initialFolder: IFolderModel = {
    folderId: 0,
    folderName: "My Files",
    parentFolderIds: "0 ",
    description: "My Files Description",
    createdBy: 0,
    createdDate: new Date(),
    expiresDays: 0,
    parentId: 0,
    owner: "Only You",
    permissionGroupId: ShareFolderTypes.NONE,
    isPermissiomInherited: false,
    isPrivate: false,
    isFolderNotificationActive: false,
};

export const rootFolder: IFolderModel = {
    ...initialFolder,
    folderName: "My Files",
    path: "My Files",
};

export interface ISharedFolderPermissionViewModel {
    folderId: number,
    userId: number,
    permissionGroupId: ShareFolderTypes,
    sharedFolderId?: number,
}

export interface ISharedFolderUserModel {
    userId: number;
    shareFolderUserType: ShareFolderUserType;
    firstName: string;
    lastName: string;
    emailAddress: string;
}

export interface ISharedFolderPermissionDetailViewModel {
    folderId: number;
    userId: number;
    firstName: string;
    lastName: string;
    emailAddress: string;
    permissionGroupId: ShareFolderTypes;
    sharedFolderId: number;
}

export interface ISharedFolderGroupPermissionViewModel {
    folderId: number;
    groupId: number;
    permissionGroupId: ShareFolderTypes;
    sharedFolderGroupId?: number;
}

export interface ISharedFolderGroupPermissionDetailViewModel extends ISharedFolderGroupPermissionViewModel {
    groupName: string;
}


export interface IFolderPermissionViewModel {
    folderId: number;
    userPermissions: ISharedFolderPermissionViewModel[];
    groupPermissions: ISharedFolderGroupPermissionViewModel[];
}

export interface IMessageFilesViewModel {
    messageGuid: string;
    messageId: number;
    files: IFileModel[];
    senderEmail: string;
    messageSource: MessageSource;
    messageType?: MessageType;
}

export interface IMyFilesDownloadPayload {
    messageFiles: IMessageFilesViewModel[];
    documentRequestFiles: IDocumentRequestFile[];
}